module.exports = __webpack_public_path__ + "static/carousel-07@2x-7ca33bc64608986e79e4b9afd89caf57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/carousel-07@2x.jpg
// module id = 2524
// module chunks = 168707334958949